import classNames from 'classnames'
import sharedStyles from '../../Settings.module.css'
import { getIcon } from '../../../../common/components/icons/utils'
import styles from './OrganizationInfo.module.css'
import { useTranslation } from 'react-i18next'
import { safeIsNullOrEmpty } from '../../../../util/string'
import { NewBusinessInfo } from '../../../../types/commonTypes'
import { ToggleSwitch } from '../../../../common/components/ToggleSwitch/ToggleSwitch'
import { useCallback } from 'react'
import { useUser } from '../../../../contexts/userContext'
import { OrganizationLicenceInfo } from './OrganizationLicenceInfo'

type OrganizationInfoProps = {
  name: string
  membersCount?: number
  licenceEndDate: string
  maxMembersCount: number | null
  businessInfo: NewBusinessInfo | null
  engineRounds?: number
  hasSaigeAccess: boolean
  limitMembers: boolean
  orgHasSaigeAccess: boolean
  saigeAllMembers: boolean
  onSetAllMembersSaigeAccess: (enabledState: boolean) => Promise<boolean>
}

export const OrganizationInfo: React.FC<OrganizationInfoProps> = ({
  name,
  membersCount,
  maxMembersCount,
  businessInfo,
  engineRounds,
  hasSaigeAccess,
  limitMembers,
  orgHasSaigeAccess,
  saigeAllMembers,
  licenceEndDate,
  onSetAllMembersSaigeAccess,
}) => {
  const { t } = useTranslation()
  const { user } = useUser()

  const internalSetAllMembersSaigeAccess = useCallback(
    (evt: any) => {
      onSetAllMembersSaigeAccess(evt.target.checked)
    },
    [onSetAllMembersSaigeAccess],
  )

  return (
    <div className={styles.mainInfoContainer}>
      <OrganizationLicenceInfo
        name={name}
        membersCount={membersCount}
        maxMembersCount={maxMembersCount}
        licenceEndDate={licenceEndDate}
        businessInfo={businessInfo}
        limitMembers={limitMembers}
      />
      {!safeIsNullOrEmpty(engineRounds) && hasSaigeAccess && orgHasSaigeAccess && (
        <div className={classNames(sharedStyles.sectionCardContainer, styles.saigeContainer)}>
          <div className={styles.saigeIconContainer}>
            <span>{getIcon('magicWand')}</span>
          </div>
          <div className={styles.saigeContent}>
            <span className='normal'>
              {t('settings_organization.org_info.saige_rounds_left', {
                saige_tokens: engineRounds,
                defaultValue: 'Saige tokens: %{saige_tokens}',
              })}
            </span>
            {user?.isBusinessAdmin && (
              <div className={styles.orgSaigeRow}>
                {t('settings_prganization.org_info.saige_all_members', 'Saige for all members')}
                <ToggleSwitch onChange={internalSetAllMembersSaigeAccess} defaultChecked={saigeAllMembers} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
